module.exports = __webpack_public_path__ + "static/media/n26-logo.e4c5369e.svg";